export default {
  // Hero
  eventHeroTag: "Events & Networking",
  eventHeroTitle1: "Connect, Learn",
  eventHeroTitle2: "& Grow Together",
  eventHeroDesc: "AIP hosts and curates conferences, workshops, and webinars that bring together investors, entrepreneurs, and government stakeholders across East Africa.",
  eventTypeConference: "Conferences",
  eventTypeWorkshop: "Workshops",
  eventTypeWebinar: "Webinars",
  eventTypeNetworking: "Networking",
  eventCtaUpcoming: "View Upcoming Events",
  eventCtaPast: "Past Events",
  eventStat1: "Events Hosted",
  eventStat2: "Total Attendees",
  eventStat3: "Speakers",
  eventStat4: "Countries Represented",
  eventFeatured: "Featured Event",
  eventTagUpcoming: "Upcoming · Featured",
  eventSpeakers: "Speakers",
  eventExpected: "Expected",
  eventSpotsLeft: "Spots Left",
  eventRegistered: "registered",
  eventFull: "full",

  // Upcoming
  upcomingTag: "Upcoming",
  upcomingTitle1: "Upcoming",
  upcomingTitle2: "Events",
  upcomingDesc: "Register now and secure your spot at our upcoming events.",
  upcomingCount: "events scheduled",
  upcomingOnline: "Online",
  upcomingInPerson: "In-Person",
  upcomingSpotsLeft: "spots left",
  upcomingViewDetails: "View Details",
  upcomingRegister: "Register Now",

  // Past
  pastTag: "Archive",
  pastTitle1: "Past",
  pastTitle2: "Events",
  pastDesc: "A look back at our events that shaped connections across East Africa.",
  pastAttendees: "attendees",

  // Detail
  detailBack: "Back to Events",
  detailAbout: "About this Event",
  detailDate: "Date",
  detailLocation: "Location",
  detailSector: "Sector",
  detailAgenda: "Event Agenda",
  detailSpeakers: "Speakers",
  detailAttendance: "Event Attendance",
  detailParticipants: "participants attended this event",
  detailPastMessage: "Event Has Concluded",
  detailPastDesc: "This event is no longer accepting registrations.",
  detailPastCta: "View Upcoming Events",
  detailRegisterTitle: "Register for this Event",
  detailRegisterDesc: "Secure your spot — limited places available.",
  detailRegistered: "registered",
  detailSpotsLeft: "spots left",
  detailFormName: "Full Name",
  detailFormEmail: "Email",
  detailFormCompany: "Company",
  detailFormPhone: "Phone",
  detailFormSubmit: "Register Now",
  detailFormSubmitting: "Registering...",
  detailFormSuccessTitle: "Registration Confirmed!",
  detailFormSuccessBody: "Check your email for confirmation details.",
};